<div class="icon--container">
  <div class="loader"></div>
</div>
